import React, {useEffect} from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../auth';
import { jwtDecode } from 'jwt-decode';
import { hasPermission } from '../permissionsMapping';
import { useNotifications } from '../notifications';

const ProtectedRoute = ({
    hasEvaluationRequired = false,
    adminOnly = false,
    providerOnly = false,
    requiredPermission = null
}) => {
  const { user, token, loading, logout, permissions, refreshPermissions } = useAuth();
  const {refreshNotifications} = useNotifications();
  const location = useLocation();


  useEffect(() => {
    const checkPermissions = async () => {
      if (user?.id && refreshPermissions) {
        try {
          const hasChanged = await refreshPermissions(user.id);
          if (hasChanged) {
          }
        } catch (error) {
          console.error('Error al verificar permisos:', error);
        }
      }
    };

    checkPermissions();
  }, [location.pathname, user?.id, refreshPermissions]);

  useEffect(() => {
    if (user?.supplierId) {
      refreshNotifications();
    }
  }, [location.pathname, user?.supplierId, refreshNotifications]);

  if (loading) {
    return null; 
  }

  if (token) {
    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      
      if (decoded.exp < currentTime) {
        logout();
        return <Navigate to="/" replace />;
      }
    } catch (error) {
      console.error('Error al decodificar el token:', error);
      logout();
      return <Navigate to="/" replace />;
    }
  }

  if (!token) {
    return <Navigate to="/" replace />;
  }


  if (!user) {
    return null;  
  }
  

  if (requiredPermission && !hasPermission(permissions, requiredPermission)) {
    return <Navigate to="/acceso-restringido" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;